export default __webpack_public_path__ + "static/media/cloud.b412ab0f.png";